module.exports = __webpack_public_path__ + "img/Powered by Sally@3x.718f6e5b.png";